export function navigationClicked (workspace, type) {
  window.analytics.track('Navigation Clicked', {
    workspace_id: workspace.id,
    workspace_slug: workspace.slug,
    type
  })
}



// WEBPACK FOOTER //
// ./analytics/main-navigation.js